import React from "react";

import { rhythm } from "../utils/typography";

const bios = {
  mitch: {
    name: "Mitch",
    description: "The Dad",
    img: require("./img/mitch.png"),
    avatar: (
      <img
        src={require("./img/mitch.png")}
        alt={`Ryan Mitchell`}
        style={{
          border: "1px solid #cccccc",
          borderRadius: "100%",
          marginRight: rhythm(1 / 2),
          marginBottom: 0,
          width: rhythm(2),
          height: rhythm(2)
        }}
      />
    )
  },
  brynn: {
    name: "Brynn",
    description: "The Daughter",
    img: require("./img/brynn.png"),
    avatar: (
      <img
        src={require("./img/brynn.png")}
        alt={`Brynn Mitchell`}
        style={{
          border: "1px solid #cccccc",
          borderRadius: "100%",
          marginRight: rhythm(1 / 2),
          marginBottom: 0,
          width: rhythm(2),
          height: rhythm(2)
        }}
      />
    )
  },
  kian: {
    name: "Kian",
    description: "The Son",
    img: require("./img/kian.png"),
    avatar: (
      <img
        src={require("./img/kian.png")}
        alt={`Kian Mitchell`}
        style={{
          border: "1px solid #cccccc",
          borderRadius: "100%",
          marginRight: rhythm(1 / 2),
          marginBottom: 0,
          width: rhythm(2),
          height: rhythm(2)
        }}
      />
    )
  },
  delia: {
    name: "Delia",
    description: "The Mom",
    img: require("./img/delia.png"),
    avatar: (
      <img
        src={require("./img/delia.png")}
        alt={`Delia Mitchell`}
        style={{
          border: "1px solid #cccccc",
          borderRadius: "100%",
          marginRight: rhythm(1 / 2),
          marginBottom: 0,
          width: rhythm(2),
          height: rhythm(2)
        }}
      />
    )
  }
};

export default bios;



// WEBPACK FOOTER //
// ./src/bios/index.js